export const BaseUrl = "https://apis.u-vault.io/";
// export const BaseUrl = "https://uvault-apis.zip2box.com/";
// export const BaseUrl = process.env.BASE_URL;